import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ListGroup } from 'reactstrap';
import { getSelectedData } from './helper';
import './style.css';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'white' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
    border: '1px solid #c0c5ce',
    borderRadius: '6px'
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '	#428bca' : 'white',
    padding: grid,
    width: 190,
    height: 300,
    overflowY: 'auto'
});

class LevelOneKeyFieldSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            selected: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            let tempSelectedData = getSelectedData(this.props.data, this.props.selectedData);
            this.setState({
                items: tempSelectedData,
                selected: this.props.selectedData
            })
        }
    }

    /**
     * A semi-generic way to handle multiple lists. Matches
     * the IDs of the droppable container to the names of the
     * source arrays stored in the state.
     */
    id2List = {
        droppable: 'items',
        droppable2: 'selected'
    };

    getList = id => this.state[this.id2List[id]];

    onDragEnd = result => {
        const { source, destination } = result;
        // dropped outside the list
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {
            const items = reorder(
                this.getList(source.droppableId),
                source.index,
                destination.index
            );
            let state = { items };
            if (source.droppableId === 'droppable2') {
                state = { selected: items };
            }
            this.props.levelOneKeySelectCallback(items)
            this.setState(state);
        } else {
            const result = move(
                this.getList(source.droppableId),
                this.getList(destination.droppableId),
                source,
                destination
            );
            this.setState({
                items: result.droppable,
                selected: result.droppable2
            }, () => {
                this.props.levelOneKeySelectCallback(result.droppable2)
            });
        }
    };

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <section style={{ marginBottom: "1%" }} className="d-flex align-items-center slosh-bucket">
                    <ListGroup className="border w-40 unselected-list">
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {(this.state.items && this.state.items.length > 0) ? this.state.items.map((item, index) => (
                                        <Draggable
                                            key={item.fieldName}
                                            draggableId={item.fieldName}
                                            index={index} >
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    <div>{item.fieldName}</div>
                                                    <span style={{ fontSize: '10px' }}>({item.keyFieldType})</span>
                                                </div>
                                            )}
                                        </Draggable>
                                    )) : <div className="no-data-message">No Data</div>}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </ListGroup>
                    <ListGroup className="border w-40 selected-list">
                        <Droppable droppableId="droppable2">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {this.state.selected.map((item, index) => (
                                        <Draggable
                                            key={item.fieldName}
                                            draggableId={item.fieldName}
                                            index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    <div>{item.fieldName}</div>
                                                    <span style={{ fontSize: '10px' }}>({item.keyFieldType})</span>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </ListGroup>
                </section>
            </DragDropContext >
        );
    }
}
export default LevelOneKeyFieldSelect;